import { render, staticRenderFns } from "./material.vue?vue&type=template&id=7073f26c"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"
import style0 from "./material.vue?vue&type=style&index=0&id=7073f26c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports